// extracted by mini-css-extract-plugin
export default {"chatChoice":"ChatChoice_chatChoice__q0Q74"};